export default "__VITE_ASSET__CVD4Qw$Y__"